/* eslint-disable no-unused-vars */
const options = { day: 'numeric', year: 'numeric', month: 'short' };
const today = new Date();

export const ISOToMDY = (isoformat) => new Date(isoformat).toLocaleDateString('en-US', options);
export const Days = (from, to) => {};
export const ISOToDMY = (date) => new Date(date).toUTCString().slice(4, 16);
